<div fxLayout="column" fxLayoutAlign="start center" class="m-2 p-1 pb-3 h-100">
    <mat-card fxFlex fxLayout="column">
        <mat-card-header>
            <mat-card-title>
                {{ "SELECT-BUSINESS.SELECT-BUSINESS" | translate}}
              </mat-card-title>
              <mat-card-subtitle>
                  <p [innerHTML]="'SELECT-BUSINESS.TITLE' | translate"></p>
              </mat-card-subtitle>
        </mat-card-header>

          <mat-card-content fxFlex="auto" perfectScrollbar class="pl-3 pr-3" style="overflow-y: auto;">
              <mat-action-list *ngFor="let item of businessList">
                  <button mat-button fxFlexLayout="column" fxLayoutAlign="start" class="w-100 pl-0 pr-0" (click)="gotoNewCustomer(item.Value)"> {{ item.Text}} </button>  
                  <mat-divider [inset]="true"></mat-divider>       
                </mat-action-list>
          </mat-card-content>
          
          <mat-card-actions>
              <div fxLayoutAlign="center" class="p-2 pb-3">
                  <button mat-raised-button class="mat-elevation-z6 ml-3" type="button" (click)="onCancel($event)">{{ 'COMMON.CANCEL' | translate }}</button>
              </div>
          </mat-card-actions>
      
    </mat-card>
</div>